/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgFeatureFieldsFragment = { __typename?: 'OrgFeatureModel', feature_id: string, name: string, display_name: string, description?: string | null, category: string, display_order: number, patient_display_name?: string | null, is_available_for_plan: boolean, is_enabled: boolean };

export type ListFeatureCatalogQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ListFeatureCatalogQuery = { __typename?: 'Query', listFeatureCatalog: Array<{ __typename?: 'OrgFeatureModel', feature_id: string, name: string, display_name: string, description?: string | null, category: string, display_order: number, patient_display_name?: string | null, is_available_for_plan: boolean, is_enabled: boolean }> };

export type CustomPlanFieldsFragment = { __typename?: 'CustomPlanModel', plan_id: string, account_id: string, name: string, description?: string | null, display_order: number, seats: number, assigned_seats: number, feature_ids: Array<string> };

export type PatientSeatSummaryFieldsFragment = { __typename?: 'PatientSeatSummaryModel', account_id: string, total?: number | null, allocated: number, remaining?: number | null };

export type OrgFeatureChangeFieldsFragment = { __typename?: 'OrgFeatureChangeModel', feature_id: string, display_name: string, affected_plans: Array<{ __typename?: 'PlanReferenceModel', plan_id: string, name: string }> };

export type ListOrgFeaturesQueryVariables = Types.Exact<{
  input: Types.OrgScopedInput;
}>;


export type ListOrgFeaturesQuery = { __typename?: 'Query', listOrgFeatures: Array<{ __typename?: 'OrgFeatureModel', feature_id: string, name: string, display_name: string, description?: string | null, category: string, display_order: number, patient_display_name?: string | null, is_available_for_plan: boolean, is_enabled: boolean }> };

export type ListCustomPlansQueryVariables = Types.Exact<{
  input: Types.OrgScopedInput;
}>;


export type ListCustomPlansQuery = { __typename?: 'Query', listCustomPlans: Array<{ __typename?: 'CustomPlanModel', plan_id: string, account_id: string, name: string, description?: string | null, display_order: number, seats: number, assigned_seats: number, feature_ids: Array<string> }> };

export type GetPatientSeatSummaryQueryVariables = Types.Exact<{
  input: Types.OrgScopedInput;
}>;


export type GetPatientSeatSummaryQuery = { __typename?: 'Query', getPatientSeatSummary: { __typename?: 'PatientSeatSummaryModel', account_id: string, total?: number | null, allocated: number, remaining?: number | null } };

export type PreviewOrgFeatureChangeQueryVariables = Types.Exact<{
  input: Types.OrgFeatureSelectionInput;
}>;


export type PreviewOrgFeatureChangeQuery = { __typename?: 'Query', previewOrgFeatureChange: { __typename?: 'OrgFeatureChangePreviewModel', to_disable: Array<{ __typename?: 'OrgFeatureChangeModel', feature_id: string, display_name: string, affected_plans: Array<{ __typename?: 'PlanReferenceModel', plan_id: string, name: string }> }>, to_enable: Array<{ __typename?: 'OrgFeatureChangeModel', feature_id: string, display_name: string, affected_plans: Array<{ __typename?: 'PlanReferenceModel', plan_id: string, name: string }> }> } };

export type UpdateOrgFeaturesMutationVariables = Types.Exact<{
  input: Types.OrgFeatureSelectionInput;
}>;


export type UpdateOrgFeaturesMutation = { __typename?: 'Mutation', updateOrgFeatures: Array<{ __typename?: 'OrgFeatureModel', feature_id: string, name: string, display_name: string, description?: string | null, category: string, display_order: number, patient_display_name?: string | null, is_available_for_plan: boolean, is_enabled: boolean }> };

export type SaveCustomPlansMutationVariables = Types.Exact<{
  input: Types.SaveCustomPlansInput;
}>;


export type SaveCustomPlansMutation = { __typename?: 'Mutation', saveCustomPlans: Array<{ __typename?: 'CustomPlanModel', plan_id: string, account_id: string, name: string, description?: string | null, display_order: number, seats: number, assigned_seats: number, feature_ids: Array<string> }> };

export type UpdatePatientSeatsMutationVariables = Types.Exact<{
  input: Types.UpdatePatientSeatsInput;
}>;


export type UpdatePatientSeatsMutation = { __typename?: 'Mutation', updatePatientSeats: { __typename?: 'PatientSeatSummaryModel', account_id: string, total?: number | null, allocated: number, remaining?: number | null } };

export const OrgFeatureFieldsFragmentDoc = gql`
    fragment OrgFeatureFields on OrgFeatureModel {
  feature_id
  name
  display_name
  description
  category
  display_order
  patient_display_name
  is_available_for_plan
  is_enabled
}
    `;
export const CustomPlanFieldsFragmentDoc = gql`
    fragment CustomPlanFields on CustomPlanModel {
  plan_id
  account_id
  name
  description
  display_order
  seats
  assigned_seats
  feature_ids
}
    `;
export const PatientSeatSummaryFieldsFragmentDoc = gql`
    fragment PatientSeatSummaryFields on PatientSeatSummaryModel {
  account_id
  total
  allocated
  remaining
}
    `;
export const OrgFeatureChangeFieldsFragmentDoc = gql`
    fragment OrgFeatureChangeFields on OrgFeatureChangeModel {
  feature_id
  display_name
  affected_plans {
    plan_id
    name
  }
}
    `;
export const ListFeatureCatalogDocument = gql`
    query listFeatureCatalog {
  listFeatureCatalog {
    ...OrgFeatureFields
  }
}
    ${OrgFeatureFieldsFragmentDoc}`;
export function useListFeatureCatalogQuery(baseOptions?: Apollo.QueryHookOptions<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>(ListFeatureCatalogDocument, options);
      }
export function useListFeatureCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>(ListFeatureCatalogDocument, options);
        }
// @ts-ignore
export function useListFeatureCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>;
export function useListFeatureCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<ListFeatureCatalogQuery | undefined, ListFeatureCatalogQueryVariables>;
export function useListFeatureCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>(ListFeatureCatalogDocument, options);
        }
export type ListFeatureCatalogQueryHookResult = ReturnType<typeof useListFeatureCatalogQuery>;
export type ListFeatureCatalogLazyQueryHookResult = ReturnType<typeof useListFeatureCatalogLazyQuery>;
export type ListFeatureCatalogSuspenseQueryHookResult = ReturnType<typeof useListFeatureCatalogSuspenseQuery>;
export type ListFeatureCatalogQueryResult = Apollo.QueryResult<ListFeatureCatalogQuery, ListFeatureCatalogQueryVariables>;
export const ListOrgFeaturesDocument = gql`
    query listOrgFeatures($input: OrgScopedInput!) {
  listOrgFeatures(input: $input) {
    ...OrgFeatureFields
  }
}
    ${OrgFeatureFieldsFragmentDoc}`;
export function useListOrgFeaturesQuery(baseOptions: Apollo.QueryHookOptions<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables> & ({ variables: ListOrgFeaturesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>(ListOrgFeaturesDocument, options);
      }
export function useListOrgFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>(ListOrgFeaturesDocument, options);
        }
// @ts-ignore
export function useListOrgFeaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>;
export function useListOrgFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>): Apollo.UseSuspenseQueryResult<ListOrgFeaturesQuery | undefined, ListOrgFeaturesQueryVariables>;
export function useListOrgFeaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>(ListOrgFeaturesDocument, options);
        }
export type ListOrgFeaturesQueryHookResult = ReturnType<typeof useListOrgFeaturesQuery>;
export type ListOrgFeaturesLazyQueryHookResult = ReturnType<typeof useListOrgFeaturesLazyQuery>;
export type ListOrgFeaturesSuspenseQueryHookResult = ReturnType<typeof useListOrgFeaturesSuspenseQuery>;
export type ListOrgFeaturesQueryResult = Apollo.QueryResult<ListOrgFeaturesQuery, ListOrgFeaturesQueryVariables>;
export const ListCustomPlansDocument = gql`
    query listCustomPlans($input: OrgScopedInput!) {
  listCustomPlans(input: $input) {
    ...CustomPlanFields
  }
}
    ${CustomPlanFieldsFragmentDoc}`;
export function useListCustomPlansQuery(baseOptions: Apollo.QueryHookOptions<ListCustomPlansQuery, ListCustomPlansQueryVariables> & ({ variables: ListCustomPlansQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListCustomPlansQuery, ListCustomPlansQueryVariables>(ListCustomPlansDocument, options);
      }
export function useListCustomPlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListCustomPlansQuery, ListCustomPlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListCustomPlansQuery, ListCustomPlansQueryVariables>(ListCustomPlansDocument, options);
        }
// @ts-ignore
export function useListCustomPlansSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListCustomPlansQuery, ListCustomPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListCustomPlansQuery, ListCustomPlansQueryVariables>;
export function useListCustomPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCustomPlansQuery, ListCustomPlansQueryVariables>): Apollo.UseSuspenseQueryResult<ListCustomPlansQuery | undefined, ListCustomPlansQueryVariables>;
export function useListCustomPlansSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListCustomPlansQuery, ListCustomPlansQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListCustomPlansQuery, ListCustomPlansQueryVariables>(ListCustomPlansDocument, options);
        }
export type ListCustomPlansQueryHookResult = ReturnType<typeof useListCustomPlansQuery>;
export type ListCustomPlansLazyQueryHookResult = ReturnType<typeof useListCustomPlansLazyQuery>;
export type ListCustomPlansSuspenseQueryHookResult = ReturnType<typeof useListCustomPlansSuspenseQuery>;
export type ListCustomPlansQueryResult = Apollo.QueryResult<ListCustomPlansQuery, ListCustomPlansQueryVariables>;
export const GetPatientSeatSummaryDocument = gql`
    query getPatientSeatSummary($input: OrgScopedInput!) {
  getPatientSeatSummary(input: $input) {
    ...PatientSeatSummaryFields
  }
}
    ${PatientSeatSummaryFieldsFragmentDoc}`;
export function useGetPatientSeatSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables> & ({ variables: GetPatientSeatSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>(GetPatientSeatSummaryDocument, options);
      }
export function useGetPatientSeatSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>(GetPatientSeatSummaryDocument, options);
        }
// @ts-ignore
export function useGetPatientSeatSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>;
export function useGetPatientSeatSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>): Apollo.UseSuspenseQueryResult<GetPatientSeatSummaryQuery | undefined, GetPatientSeatSummaryQueryVariables>;
export function useGetPatientSeatSummarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>(GetPatientSeatSummaryDocument, options);
        }
export type GetPatientSeatSummaryQueryHookResult = ReturnType<typeof useGetPatientSeatSummaryQuery>;
export type GetPatientSeatSummaryLazyQueryHookResult = ReturnType<typeof useGetPatientSeatSummaryLazyQuery>;
export type GetPatientSeatSummarySuspenseQueryHookResult = ReturnType<typeof useGetPatientSeatSummarySuspenseQuery>;
export type GetPatientSeatSummaryQueryResult = Apollo.QueryResult<GetPatientSeatSummaryQuery, GetPatientSeatSummaryQueryVariables>;
export const PreviewOrgFeatureChangeDocument = gql`
    query previewOrgFeatureChange($input: OrgFeatureSelectionInput!) {
  previewOrgFeatureChange(input: $input) {
    to_disable {
      ...OrgFeatureChangeFields
    }
    to_enable {
      ...OrgFeatureChangeFields
    }
  }
}
    ${OrgFeatureChangeFieldsFragmentDoc}`;
export function usePreviewOrgFeatureChangeQuery(baseOptions: Apollo.QueryHookOptions<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables> & ({ variables: PreviewOrgFeatureChangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>(PreviewOrgFeatureChangeDocument, options);
      }
export function usePreviewOrgFeatureChangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>(PreviewOrgFeatureChangeDocument, options);
        }
// @ts-ignore
export function usePreviewOrgFeatureChangeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>;
export function usePreviewOrgFeatureChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewOrgFeatureChangeQuery | undefined, PreviewOrgFeatureChangeQueryVariables>;
export function usePreviewOrgFeatureChangeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>(PreviewOrgFeatureChangeDocument, options);
        }
export type PreviewOrgFeatureChangeQueryHookResult = ReturnType<typeof usePreviewOrgFeatureChangeQuery>;
export type PreviewOrgFeatureChangeLazyQueryHookResult = ReturnType<typeof usePreviewOrgFeatureChangeLazyQuery>;
export type PreviewOrgFeatureChangeSuspenseQueryHookResult = ReturnType<typeof usePreviewOrgFeatureChangeSuspenseQuery>;
export type PreviewOrgFeatureChangeQueryResult = Apollo.QueryResult<PreviewOrgFeatureChangeQuery, PreviewOrgFeatureChangeQueryVariables>;
export const UpdateOrgFeaturesDocument = gql`
    mutation updateOrgFeatures($input: OrgFeatureSelectionInput!) {
  updateOrgFeatures(input: $input) {
    ...OrgFeatureFields
  }
}
    ${OrgFeatureFieldsFragmentDoc}`;
export type UpdateOrgFeaturesMutationFn = Apollo.MutationFunction<UpdateOrgFeaturesMutation, UpdateOrgFeaturesMutationVariables>;
export function useUpdateOrgFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgFeaturesMutation, UpdateOrgFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgFeaturesMutation, UpdateOrgFeaturesMutationVariables>(UpdateOrgFeaturesDocument, options);
      }
export type UpdateOrgFeaturesMutationHookResult = ReturnType<typeof useUpdateOrgFeaturesMutation>;
export type UpdateOrgFeaturesMutationResult = Apollo.MutationResult<UpdateOrgFeaturesMutation>;
export type UpdateOrgFeaturesMutationOptions = Apollo.BaseMutationOptions<UpdateOrgFeaturesMutation, UpdateOrgFeaturesMutationVariables>;
export const SaveCustomPlansDocument = gql`
    mutation saveCustomPlans($input: SaveCustomPlansInput!) {
  saveCustomPlans(input: $input) {
    ...CustomPlanFields
  }
}
    ${CustomPlanFieldsFragmentDoc}`;
export type SaveCustomPlansMutationFn = Apollo.MutationFunction<SaveCustomPlansMutation, SaveCustomPlansMutationVariables>;
export function useSaveCustomPlansMutation(baseOptions?: Apollo.MutationHookOptions<SaveCustomPlansMutation, SaveCustomPlansMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCustomPlansMutation, SaveCustomPlansMutationVariables>(SaveCustomPlansDocument, options);
      }
export type SaveCustomPlansMutationHookResult = ReturnType<typeof useSaveCustomPlansMutation>;
export type SaveCustomPlansMutationResult = Apollo.MutationResult<SaveCustomPlansMutation>;
export type SaveCustomPlansMutationOptions = Apollo.BaseMutationOptions<SaveCustomPlansMutation, SaveCustomPlansMutationVariables>;
export const UpdatePatientSeatsDocument = gql`
    mutation updatePatientSeats($input: UpdatePatientSeatsInput!) {
  updatePatientSeats(input: $input) {
    ...PatientSeatSummaryFields
  }
}
    ${PatientSeatSummaryFieldsFragmentDoc}`;
export type UpdatePatientSeatsMutationFn = Apollo.MutationFunction<UpdatePatientSeatsMutation, UpdatePatientSeatsMutationVariables>;
export function useUpdatePatientSeatsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientSeatsMutation, UpdatePatientSeatsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientSeatsMutation, UpdatePatientSeatsMutationVariables>(UpdatePatientSeatsDocument, options);
      }
export type UpdatePatientSeatsMutationHookResult = ReturnType<typeof useUpdatePatientSeatsMutation>;
export type UpdatePatientSeatsMutationResult = Apollo.MutationResult<UpdatePatientSeatsMutation>;
export type UpdatePatientSeatsMutationOptions = Apollo.BaseMutationOptions<UpdatePatientSeatsMutation, UpdatePatientSeatsMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useListFeatureCatalog = withQueryResponseHandler(useListFeatureCatalogQuery);
export const useListOrgFeatures = withQueryResponseHandler(useListOrgFeaturesQuery);
export const useListCustomPlans = withQueryResponseHandler(useListCustomPlansQuery);
export const useGetPatientSeatSummary = withQueryResponseHandler(useGetPatientSeatSummaryQuery);
export const usePreviewOrgFeatureChange = withQueryResponseHandler(usePreviewOrgFeatureChangeQuery);
export const useUpdateOrgFeatures = withMutationResponseHandler(useUpdateOrgFeaturesMutation, "updateOrgFeatures");
export const useSaveCustomPlans = withMutationResponseHandler(useSaveCustomPlansMutation, "saveCustomPlans");
export const useUpdatePatientSeats = withMutationResponseHandler(useUpdatePatientSeatsMutation, "updatePatientSeats");